import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const WhatsappIcon = (props: SvgProps) => (
  <Svg width={16} height={16} {...props}>
    <Path
      fill="#f2faff"
      d="M8.069 15.362a7.443 7.443 0 0 1-3.555-.903l-.174-.096-3.559.934.951-3.475-.104-.181a7.43 7.43 0 0 1-.991-3.714C.64 3.832 3.973.5 8.068.5a7.384 7.384 0 0 1 5.257 2.179A7.388 7.388 0 0 1 15.5 7.935c-.002 4.095-3.335 7.427-7.431 7.427z"
    />
    <Path
      fill="#788b9c"
      d="M8.068 1a6.89 6.89 0 0 1 4.903 2.032A6.89 6.89 0 0 1 15 7.934a6.94 6.94 0 0 1-6.934 6.929 6.946 6.946 0 0 1-3.312-.843l-.349-.19-.383.1-2.529.663.668-2.438.11-.403-.209-.362a6.936 6.936 0 0 1-.925-3.463C1.139 4.108 4.248 1 8.068 1m0-1C3.697 0 .139 3.557.137 7.928a7.9 7.9 0 0 0 1.059 3.964L.071 16l4.204-1.102a7.928 7.928 0 0 0 3.79.965h.003c4.371 0 7.929-3.557 7.931-7.928a7.881 7.881 0 0 0-2.322-5.609A7.87 7.87 0 0 0 8.068 0z"
    />
    <Path
      fill="#79ba7e"
      d="M8.067 13.863c-.99 0-1.97-.25-2.833-.721l-.697-.38-.768.201-.853.224.21-.767.22-.805-.418-.723a5.932 5.932 0 0 1-.791-2.963A5.939 5.939 0 0 1 8.068 2a5.9 5.9 0 0 1 4.196 1.738A5.9 5.9 0 0 1 14 7.933a5.939 5.939 0 0 1-5.933 5.93z"
    />
    <Path
      fill="#fff"
      d="M11.507 9.51c-.189-.094-1.115-.55-1.287-.613-.173-.063-.299-.094-.424.094-.127.189-.488.613-.597.739s-.22.141-.409.047c-.188-.094-.796-.293-1.515-.935a5.662 5.662 0 0 1-1.048-1.305c-.11-.189-.012-.29.083-.384.085-.085.189-.22.283-.33.094-.11.126-.189.189-.314.063-.126.032-.236-.016-.33-.048-.095-.425-1.023-.582-1.399-.153-.368-.309-.318-.424-.323a6.904 6.904 0 0 0-.361-.007.689.689 0 0 0-.502.236c-.172.189-.66.644-.66 1.571s.675 1.823.769 1.949 1.328 2.028 3.219 2.844c.449.194.801.31 1.074.397.451.143.862.123 1.187.074.362-.054 1.115-.456 1.272-.896.157-.44.157-.817.11-.896-.047-.077-.173-.125-.361-.219z"
    />
  </Svg>
)
export default WhatsappIcon
